import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import {
  DxiColumnComponent,
  DxiValidationRuleComponent,
  DxoEditingComponent,
  DxoExportComponent,
  DxoFilterRowComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import CustomStore from 'devextreme/data/custom_store';
import { firstValueFrom } from 'rxjs';
import { GestArticoliBaseComponent } from 'src/app/shared/components/gest-articoli-base/gest-articoli-base.component';
import { MansioniService } from 'src/app/shared/services/mansioni.service';
import { GridExportExcel } from 'src/app/utils/grid-export-excel';

@Component({
  selector: 'app-mansioni',
  templateUrl: './mansioni.component.html',
  imports: [
    DxDataGridComponent,
    DxoEditingComponent,
    DxoTextsComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxiColumnComponent,
    DxiValidationRuleComponent,
    DxoExportComponent,
  ],
  standalone: true,
})
export class MansioniComponent
  extends GestArticoliBaseComponent
  implements OnInit
{
  private mansioniService = inject(MansioniService);

  dataSource: any;

  onUpdating(e: any) {
    e.newData = Object.assign(e.oldData, e.newData);
  }

  ngOnInit() {
    this.loadDataSource();
  }

  loadDataSource() {
    this.dataSource = new CustomStore({
      key: 'id',
      load: () => {
        return firstValueFrom(this.mansioniService.list())
          .then((response) => {
            return {
              data: response,
            };
          })
          .catch(() => {
            throw 'Data loading error';
          });
      },
      insert: (values) => {
        return firstValueFrom(this.mansioniService.insert(values))
          .then((res) => {
            this.mansioniService.listTemp(true).subscribe();
            return res;
          })
          .catch((error: HttpErrorResponse) => {
            if (error.status == 500) {
              throw error.error.title;
            } else {
              throw 'Insert failed';
            }
          });
      },
      remove: (values) => {
        console.log(values);
        return (
          firstValueFrom(this.mansioniService.remove(values))
            .then(() => {
              console.log('delete eseguito');
              this.mansioniService.listTemp(true).subscribe();
            })
            .catch((error: HttpErrorResponse) => {
              if (error.status == 500) {
                throw error.error.title;
              } else {
                throw 'Deletion failed';
              }
            })
        );
      },
      update: (key, values) => {
        this.mansioniService.listTemp(true).subscribe();
        return firstValueFrom(this.mansioniService.update(key, values))
          .then(() => {
            this.mansioniService.listTemp(true).subscribe();
          })
          .catch((error: HttpErrorResponse) => {
            if (error.status == 500) {
              throw error.error.title;
            } else {
              throw 'Update failed';
            }
          });
      },
    });
  }

  onExporting(e: any) {
    GridExportExcel(e, 'Mansioni', 'Mansioni.xlsx');
  }
}
